import {type PlayerColor} from './PlayerState.ts'

export interface GameChatState {[key: number]: GameChatData}

export interface GameChatData {
    text: GameChatMessageData
    recipients?: PlayerColor[]
    toSpectators?: false // default: undefined will send to spectators
}

export enum GameChatType {
    Message = 0,
    SystemMessage = 1,
    UnableToSend = 2,
    ChatDisabled = 3,
    ChatEnabled = 4,
    BadLanguage = 5,
    TooLong = 6,
    Spam = 7,
    WrongCommand = 8,
    CommandCrashed = 9,
    GameCommandOnly = 10,
    EmojiTutorial = 11,
    CommandTutorial = 12,
    DisableKarmaTutorial = 13,
    PauseGameTutorial = 14,
    SpectatorCannotSendMessage = 15,
    YouAreMuted = 16,
    AdminKickedPlayer = 17,
    CanOnlyResignIn1v1 = 18,
}

export type GameChatMessageData =
{
    type: GameChatType.Message
    message: string
    from: PlayerColor
} | {
    type: GameChatType.SystemMessage
    message: string
} | {
    type: GameChatType.UnableToSend
} | {
    type: GameChatType.ChatDisabled
} | {
    type: GameChatType.ChatEnabled
} | {
    type: GameChatType.BadLanguage
} | {
    type: GameChatType.TooLong
} | {
    type: GameChatType.Spam
} | {
    type: GameChatType.WrongCommand
} | {
    type: GameChatType.CommandCrashed
} | {
    type: GameChatType.GameCommandOnly
} | {
    type: GameChatType.EmojiTutorial
    exampleString: string
    exampleEmojis: string
} | {
    type: GameChatType.CommandTutorial
    exampleString: string
} | {
    type: GameChatType.DisableKarmaTutorial
    exampleString: string
} | {
    type: GameChatType.PauseGameTutorial
    exampleString: string
} | {
    type: GameChatType.SpectatorCannotSendMessage
} | {
    type: GameChatType.YouAreMuted
    mutedUntil: string
} | {
    type: GameChatType.AdminKickedPlayer
} | {
    type: GameChatType.CanOnlyResignIn1v1
}

